<script setup lang="ts">
import EditDe23Drawer from '@/pages/erp/de/select/view/de-select-drawer.vue'
import type { De23Properties } from '@/pages/erp/de/select/db/de-select-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DESELECT',
    },
})

const tabId = ref()
const field1 = ref()
const field2 = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: 'TAB編號', key: 'tabId' },
    { title: '欄位1', key: 'field1' },
    { title: '欄位2', key: 'field2' },
    { title: '欄位3', key: 'field3' },
    { title: '欄位4', key: 'field4' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: de23sData, execute: fetchDe23s } = await useApi<any>(createUrl('/de/select/select/searchDe23', {
  query: {
    tabId,
    field1,
    field2,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): De23Properties[] => de23sData.value.data.de23Page.content)
const totalDatas = computed(() => de23sData.value.data.de23Page.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (de23Data: De23Properties) => {
  voData = de23Data
  console.log('editDe23: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (de23Data: De23Properties) => {
    voData = de23Data
    console.log('copyDe23: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (de23Data: De23Properties) => {
  await $api('/de/select/select/createDe23', {
    method: 'POST',
    body: { de23: de23Data },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDe23s()
}

const updateData = async (de23Data: De23Properties) => {
  await $api('/de/select/select/updateDe23', {
    method: 'PUT',
    body: { de23: de23Data },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDe23s()
}

  // 👉 Delete data
const deleteData = async (de23Data: De23Properties) => {
  const { tabId,field1 } = de23Data
    $swal({
    title: `確定要刪除 ${de23Data.field1} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/de/select/select/deleteDe23`, {
        method: 'DELETE',
        query: {
          tabId,field1
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchDe23s()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="tabId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入TAB編號"
          />
        </VCol>
        <VCol
          cols="12"
          sm="2"
        >
          <AppTextField
            v-model="field1"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入欄位1"
          />
        </VCol>
        <VCol
          cols="12"
          sm="2"
        >
          <AppTextField
            v-model="field2"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入欄位2"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增簡易共用表格
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.tabId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.tabId }}
          </div>
      </template>

      <template #item.field1="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.field1 }}
          </div>
      </template>

      <template #item.field2="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.field2 }}
          </div>
      </template>

      <template #item.field3="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.field3 }}
          </div>
      </template>

      <template #item.field4="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.field4 }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDe23Drawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :de23-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
